export const getYear = state => state.reportTrailerResults.getIn(['list', 'year'])
export const getData = state => state.reportTrailerResults.getIn(['list', 'data'])
export const getFetching = state => state.reportTrailerResults.getIn(['list', 'fetching'])
export const getError = state => state.reportTrailerResults.getIn(['list', 'error'])

export const getDetailsData = state => state.reportTrailerResults.getIn(['details', 'data'])
export const getDetailsFetching = state => state.reportTrailerResults.getIn(['details', 'fetching'])
export const getDetailsError = state => state.reportTrailerResults.getIn(['details', 'error'])
